import * as React from 'react';

import styled, { css } from 'styled-components';
import { getWidth } from '@components/styles';

import SnackbarBase from '@components/basics/snackbar';
import Typography from '@components/basics/typography';

export type SnackbarStatusType = 'success' | 'error';

export interface SnackbarStatusProps {
  className?: string;
  status: SnackbarStatusType;
  title: React.ReactNode;
  hideOnClose?: boolean;
  onClose?: () => void;
}

export const SnackbarStatus: React.FC<SnackbarStatusProps> = (props) => {
  const [showSnackbar, setShowSnackbar] = React.useState(true);

  return showSnackbar ? (
    <div className={props.className}>
      <SnackbarBase
        className="snackbar-status"
        content={
          <Title weight="700" status={props.status}>
            {props.title}
          </Title>
        }
        actions={
          <Typography
            className="actions-text"
            weight="700"
            onClick={() => {
              props.onClose && props.onClose();
              props.hideOnClose && setShowSnackbar(false);
            }}
          >
            Close
          </Typography>
        }
      />
    </div>
  ) : null;
};

export default styled(SnackbarStatus)`
  .snackbar-status {
    width: calc(100% - 30px);
    max-width: ${getWidth(6)};
    user-select: none;
    padding: 15px;
    background: ${(props) =>
      props.status === 'success'
        ? css`
            ${({ theme }) => theme.colors.success}
          `
        : css`
            ${({ theme }) => theme.colors.error}
          `};

    @media ${({ theme }) => theme.device.laptopS} {
      padding: 30px;
      width: 100%;
    }
  }

  .actions-text {
    color: ${({ theme }) => theme.colors.white};
    text-align: right;
    cursor: pointer;
    opacity: 1;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &:hover {
      opacity: 0.5;
    }
  }
`;

const Title = styled(Typography)<{ status: SnackbarStatusType }>`
  color: ${(props) =>
    props.status === 'success'
      ? css`
          ${({ theme }) => theme.colors.successLight}
        `
      : css`
          ${({ theme }) => theme.colors.white}
        `};
`;
